import { http } from '@article/pixel';
import LocalStorage from '@/components/commons/LocalStorage';
import { refreshApolloClient } from '@/components/commons/apollo';
// import useMutation from '@/compositions/useMutation.js';
// import { gql } from '@apollo/client/core';

const KEY_ARTICLE_USER = 'article-user';
const KEY_ARTICLE_CART = 'article-cart';
const KEY_ARTICLE_TOKEN = 'article-token';

export default class UserService {

  static #user = null;
  static #cart = null;
  static #customerToken = null;

  static setUser(user) {
    if (user) {
      try {
        LocalStorage.set(KEY_ARTICLE_USER, JSON.stringify(user));
      } catch (error) {}

      http.attach({
        __i: user.sessionId,
      });

      UserService.setCart(user.cart);
    } else {
      try {
        LocalStorage.remove(KEY_ARTICLE_USER);
      } catch (error) {}

      http.attach({});
    }

    UserService.#user = user;

    refreshApolloClient({
      restoreCache: true,
      ssr: false,
    });
  }

  static setCart(cart) {
    if (cart) {
      try {
        LocalStorage.set(KEY_ARTICLE_CART, JSON.stringify(cart));
      } catch (error) {}
    } else {
      try {
        LocalStorage.remove(KEY_ARTICLE_CART);
      } catch (error) {}
    }

    UserService.#cart = cart;
  }

  static getUser() {
    if (UserService.#user) {
      return UserService.#user;
    }

    UserService.refreshUser();
    return UserService.#user;
  }

  static refreshUser() {
    try {
      UserService.#user = JSON.parse(LocalStorage.get(KEY_ARTICLE_USER));
      UserService.setCart(UserService.#user.cart);
      http.attach({
        __i: UserService.#user.sessionId,
      });
      
      refreshApolloClient({
        restoreCache: true,
        ssr: false,
      });
    } catch (error) {
      UserService.#user = null;
      UserService.setCart(null);
      http.attach({});
    }
  }

  static getCart() {
    if (UserService.#cart) {
      return UserService.#cart;
    }

    UserService.refreshCart();
    return UserService.#cart;
  }

  static refreshCart() {
    try {
      UserService.#cart = JSON.parse(LocalStorage.get(KEY_ARTICLE_CART));
    } catch (error) {
      UserService.#cart = null;
    }
  }

  static setCustomerToken(customerToken) {
    if (customerToken) {
      try {
        LocalStorage.set(KEY_ARTICLE_TOKEN, customerToken);
      } catch (error) {}
      http.attach({
        __t: customerToken,
      }, false);
    } else {
      try {
        LocalStorage.remove(KEY_ARTICLE_TOKEN);
      } catch (error) {}
      http.attach({});
    }
  }

  static getCustomerToken() {
    if (UserService.#customerToken) {
      return UserService.#customerToken;
    }
    UserService.refreshCustomerToken();
    return UserService.#customerToken;
  }

  static refreshCustomerToken() {
    try {
      UserService.#customerToken = LocalStorage.get(KEY_ARTICLE_TOKEN);
      http.attach( {
        __t: UserService.#customerToken,
      }, false);
    } catch (error) {
      UserService.#customerToken = null;
      http.attach({});
    }
  }

  static getEmail() {
    return UserService.getUser()?.email;
  }

  static getSessionId() {
    return UserService.getUser()?.sessionId;
  }

  static isVerified() {
    return !!UserService.getUser()?.verified;
  }

  static isExpired() {
    return !!UserService.getUser()?.expired;
  }

  static isRegistered() {
    return !!UserService.getUser()?.registered;
  }

  static isTrade() {
    return !!UserService.getUser()?.isTrade;
  }

  static async login(account) {
    const result = await http.post(`/api/account/login`, { account }, null, null);
    return result;
  }

  static async validate(account) {
    const result = await http.post(`/api/account/validate`, { account }, null, null);
    return result;
  }
}
